module.exports = __webpack_public_path__ + "media/images/clearcash-logo-b925a6efdf49ff2f91ad5837c2c49249.png";